export default "__VITE_ASSET__Du5s2cpo__"